import PropTypes from "prop-types";
import { AccordionMainOption, AccordionSubOptions } from "./styled";
import { Checkbox, FlexContainers, IconButton, Paragraph2, SVG, WrapperContainer } from "../index";
import flexContainers from "../Containers/FlexContainers";
import { colors } from "../../consts";

export const AccordionOption = ({
  option,
  withCheckboxes,
  isOpen,
  onOpeningMainOption,
  onSelectMainOption,
  onSelectSubOption
}) => {
  return (
    <>
      <AccordionMainOption
        isOpen={isOpen}
        onClick={() => onOpeningMainOption(option.mainOption.id)}>
        <WrapperContainer Container={flexContainers.FlexRow} gap={16}>
          {withCheckboxes && (
            <Checkbox
              onCheck={(event) => {
                event.stopPropagation();
                onSelectMainOption && onSelectMainOption(option.mainOption.id);
              }}
              checked={option.mainOption.selected}
              partiallyChecked={option.mainOption.partiallySelected}
            />
          )}

          <Paragraph2>{option.mainOption.value}</Paragraph2>
        </WrapperContainer>

        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onOpeningMainOption(option.mainOption.id);
          }}>
          <SVG.DownArrowIcon color={colors.RAISIN_100} flipVert={isOpen} />
        </IconButton>
      </AccordionMainOption>

      <AccordionSubOptions isOpen={isOpen}>
        {option.subOptions.map((subOption) => (
          <WrapperContainer
            key={subOption.id}
            Container={FlexContainers.FlexRowStart}
            mb={24}
            gap={16}>
            {withCheckboxes && (
              <Checkbox
                onCheck={() => onSelectSubOption && onSelectSubOption(subOption.id)}
                checked={subOption.selected}
              />
            )}

            <Paragraph2>{subOption.value}</Paragraph2>
          </WrapperContainer>
        ))}
      </AccordionSubOptions>
    </>
  );
};

AccordionOption.propTypes = {
  option: PropTypes.shape({
    mainOption: PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
      partiallySelected: PropTypes.bool.isRequired
    }),
    subOptions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        selected: PropTypes.bool.isRequired
      })
    )
  }),
  withCheckboxes: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onOpeningMainOption: PropTypes.func.isRequired,
  onSelectMainOption: PropTypes.func,
  onSelectSubOption: PropTypes.func
};
